module.exports = __webpack_public_path__ + "img/MG-TITLE-01.defee5a2.png";